import moment from "moment-timezone";
import { INITIAL_STATE } from "./moduleAuthState";

export default {
  SET_ID_TOKEN(state, payload) {
    state.idToken = payload.idToken;
  },

  SET_USER(state, payload) {
    state.user = payload.user;
  },
  SET_LOGIN_SUCCESS(state) {
    state.lastLoginSuccess = moment().toISOString();
  },
  START_REFRESH_TOKEN(state, symbol) {
    state.refreshTokenRequestSymbols = [
      ...state.refreshTokenRequestSymbols,
      symbol,
    ];
  },
  FINISH_REFRESH_TOKEN(state, symbol) {
    state.refreshTokenRequestSymbols = state.refreshTokenRequestSymbols.filter(
      (sym) => sym !== symbol,
    );
  },

  RESET_STATE(state) {
    Object.assign(state, INITIAL_STATE);
  },
};
